import { inject } from '@angular/core';
import { CanActivateFn } from '@angular/router';
import { Store } from '@ngxs/store';
import { map } from 'rxjs/operators';

import { NotificationsActions } from '../store/notifications.actions';
import { NotificationsState } from '../store/notifications.state';
import { DebugHelper } from '@shared/helpers/debug.helper';

export const notificationsLoaderGuard: CanActivateFn = () => {
  const store = inject(Store);
  return store.select(NotificationsState.isLoaded())
              .pipe(
                  map((isLoaded) => {
                    if (!isLoaded) {
                      store.dispatch(new NotificationsActions.Get())
                           .subscribe({
                             error: (error) => {
                               DebugHelper.log(
                                   'NotificationsLoaderGuard: Error loading notifications',
                                   error,
                               );
                             },
                           });
                    }
                    return true;
                  }),
              );
};
